import { createMongoAbility } from '@casl/ability'

export type Actions = 'create' | 'read' | 'update' | 'delete' | 'manage'

// ใช้ string แทน specific types เพื่อให้ dynamic
export type Subjects = string | 'all'

export interface Rule { action: Actions; subject: Subjects }

// ใช้ any เพื่อให้รับ subjects ใดๆ ได้
export const ability = createMongoAbility<[Actions, any]>()
